import { Paths } from "router/Paths";
import { NotificationItemType } from "types/loadedData";

export type NotificationNavigationTarget = {
  path: string;
  state?: Record<string, any>;
};

const buildEntityPath = (basePath: string, entityId?: string) =>
  entityId ? `${basePath}/${entityId}` : basePath;

const stripRouteParam = (path: string) => path.replace(/\/:id$/, "");

export const resolveDashboardNotificationTarget = (
  notification?: NotificationItemType | null
): NotificationNavigationTarget | null => {
  const data = notification?.data || {};
  const screen = String(data.carId || notification?.entityType === "car" ? "CarScreen" : data.screen || "");
  const entityId = String(
    data.carId ||
      data.entityId ||
      data.id ||
      data.requestId ||
      data.moneyRequestId ||
      data.reportId ||
      data.userId ||
      notification?.entityId ||
      ""
  ).trim();

  switch (screen) {
    case "MessageScreen":
      return {
        path: Paths.messages,
        state: data.conversationId
          ? { conversationId: String(data.conversationId) }
          : undefined,
      };
    case "CarScreen":
    case "CarPage":
      return {
        path: buildEntityPath(stripRouteParam(Paths.car), entityId),
      };
    case "RequestScreen":
    case "CarRequestPage":
      return {
        path: Paths.carRequest,
        state: data.requestId ? { requestId: String(data.requestId) } : undefined,
      };
    case "SparePartsPage":
      return {
        path: Paths.spareParts,
        state: data.requestId ? { requestId: String(data.requestId) } : undefined,
      };
    case "MoneyRequestScreen":
    case "MoneyRequestPage":
      return {
        path: Paths.money,
        state: data.moneyRequestId
          ? { moneyRequestId: String(data.moneyRequestId) }
          : undefined,
      };
    case "ReportScreen":
    case "ReportsPage":
      return {
        path: Paths.reports,
        state: data.reportId ? { reportId: String(data.reportId) } : undefined,
      };
    case "UserScreen":
      return {
        path: buildEntityPath(stripRouteParam(Paths.user), entityId),
      };
    case "NotificationsScreen":
      return {
        path: Paths.notifications,
      };
    case "DealerLeadPage":
    case "ImporterPriceUpdateScreen":
      return {
        path: Paths.dealerMarketplace,
        state: data.leadId ? { leadId: String(data.leadId) } : undefined,
      };
    default: {
      switch (notification?.type) {
        case "message":
          return {
            path: Paths.messages,
            state: data.conversationId
              ? { conversationId: String(data.conversationId) }
              : undefined,
          };
        case "car":
          return {
            path: buildEntityPath(stripRouteParam(Paths.car), entityId),
          };
        case "request":
          if (screen === "SparePartsPage") {
            return {
              path: Paths.spareParts,
              state: data.requestId ? { requestId: String(data.requestId) } : undefined,
            };
          }
          return {
            path: Paths.carRequest,
            state: data.requestId ? { requestId: String(data.requestId) } : undefined,
          };
        case "moneyRequest":
          return {
            path: Paths.money,
            state: data.moneyRequestId
              ? { moneyRequestId: String(data.moneyRequestId) }
              : undefined,
          };
        case "report":
          return {
            path: Paths.reports,
            state: data.reportId ? { reportId: String(data.reportId) } : undefined,
          };
        case "system":
        case "marketing":
          return {
            path: Paths.notifications,
          };
        default:
          return null;
      }
    }
  }
};
